// @docs https://[domain]/api/v1/docs
export default {
  ImageUpload: "/files/image",
  FileUpload: "/files",
  FileDocument: "/files/document",
  FileUploadAll: "/files/{employeeId}",
  Detail: "/files/{name}",
  FileShare: "/files/share/{name}",
  FileShareMember: "/files/share/{name}/members",
};
